import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const avatarSrc = (url) => (url ? (url.startsWith("http") ? url : `${BACKEND}${url}`) : null);

export function Avatar({ user, size = 40, className = "" }) {
  const url = user?.profile?.avatar_url;
  const name = user?.name || user?.email || "Chef";
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const dim = { width: size, height: size };
  if (url) {
    return (
      <img src={avatarSrc(url)} alt={name} data-testid="user-avatar" style={dim}
        className={`rounded-full object-cover border border-gold/30 ${className}`} />
    );
  }
  return (
    <div data-testid="user-avatar-fallback" style={dim}
      className={`rounded-full bg-gold/15 border border-gold/30 text-gold flex items-center justify-center font-serif ${className}`}>
      <span style={{ fontSize: size * 0.4 }}>{initials}</span>
    </div>
  );
}

export default Avatar;
